import { render } from "./PuzzleGame.vue?vue&type=template&id=cc9bb8c6&scoped=true"
import script from "./PuzzleGame.vue?vue&type=script&lang=js"
export * from "./PuzzleGame.vue?vue&type=script&lang=js"

import "./PuzzleGame.vue?vue&type=style&index=0&id=cc9bb8c6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cc9bb8c6"]])

export default __exports__